import React from 'react';
import '../styles/NoMatchModal.css';

function NoMatchModal(props) {
    const propertyInfoCompare = props.propertyInfoCompare;
    const externalCompanyNoMatch = props.externalCompanyNoMatch;
    const selectedOption = props.selectedOption;
    const setSelectedOption = props.setSelectedOption;
    const setBedrooms = props.setBedrooms;
    const setBathrooms = props.setBathrooms;
    const setSquareFootage = props.setSquareFootage;
    const setYearBuilt = props.setYearBuilt;

    const selectOption = (index) => {
        setSelectedOption(index);

        const relevantObject = index === 0 ? propertyInfoCompare.old : propertyInfoCompare.new;
        setBedrooms(Number(relevantObject[0].rawValue));
        setBathrooms(Number(relevantObject[1].rawValue));
        setSquareFootage(Number(relevantObject[2].rawValue));
        setYearBuilt(Number(relevantObject[3].rawValue));
    };

    return (
        <div className="no-match-modal-container">
            {
                externalCompanyNoMatch === true ?
                <span className="body-regular colour-primary">
                    Another business has run this property before but with <span className="body-bold">different</span> property info. 
                    Please double check and select the <span className="body-bold">correct configuration</span> to run this report with.
                </span>
                :
                <span className="body-regular colour-primary">
                    You or your team have already run this property, but with different property info. 
                    You can either view the old report, or re-run the report with the new property info for{" "}
                    <span className="body-bold">
                        1 extra credit.
                    </span>
                </span>
            }
            <div className="no-match-modal-row">
                <div 
                    className={"no-match-modal-element cursor-pointer " + (selectedOption === 0 ? "no-match-modal-element-selected" : "")}
                    onClick={() => selectOption(0)}
                >
                    <div className="no-match-modal-element-inner-container">
                        <span className="heading-small-bold colour-primary">
                            Old info
                        </span>
                        {
                            propertyInfoCompare.old.map((item, index) =>
                                <div 
                                    className="no-match-modal-characteristic relative-container"
                                    key={index}
                                >
                                    <div className="no-match-modal-characteristic-label">
                                        <span className="body-regular colour-primary">
                                            {item.value}
                                        </span>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
                <div 
                    className={"no-match-modal-element cursor-pointer " + (selectedOption === 1 ? "no-match-modal-element-selected" : "")}
                    onClick={() => selectOption(1)}
                >
                    <div className="no-match-modal-element-inner-container">
                        <span className="heading-small-bold colour-primary">
                            You indicated...
                        </span>
                        {
                            propertyInfoCompare.new.map((item, index) =>
                                <div 
                                    className="no-match-modal-characteristic relative-container"
                                    key={index}
                                >
                                    <span className="body-regular colour-primary">
                                        {item.value}
                                    </span>
                                    {
                                        item.rawValue !== propertyInfoCompare.old[index].rawValue &&
                                        <span className="body-bold colour-error no-match-modal-difference">
                                            {item.rawValue - propertyInfoCompare.old[index].rawValue > 0 ? "+" : ""}
                                            {item.rawValue - propertyInfoCompare.old[index].rawValue}
                                        </span>
                                    }
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
};

export default NoMatchModal;